import { render, staticRenderFns } from "./Chapassword.vue?vue&type=template&id=50371342&scoped=true"
import script from "./Chapassword.vue?vue&type=script&lang=js"
export * from "./Chapassword.vue?vue&type=script&lang=js"
import style0 from "./Chapassword.vue?vue&type=style&index=0&id=50371342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50371342",
  null
  
)

export default component.exports